import React from "react";
import { createBrowserRouter, RouterProvider, Navigate, useParams, useSearchParams } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastContext";
import ErrorPage from "./components/ErrorPage";
import Login from "./components/Login";
import OnboardingPage from "./pages/OnboardingPage";
import SurveyFormPage from "./pages/SurveyFormPage";
import SurveyAnalysisPage from "./pages/SurveyAnalysisPage";
import HiredCandidatesFormPage from "./pages/HiredCandidatesFormPage";
import FixedQuestionsPage from "./pages/FixedQuestionsPage";
import CompanyDashboard from "./components/CompanyDashboard";
import SurveySuccess from "./components/SurveySuccess";
import ProtectedRoute from "./components/ProtectedRoute";

// Component to handle redirect from /agent/survey-form to /survey-form
const AgentSurveyFormRedirect = () => {
  const { surveyId } = useParams();
  const [searchParams] = useSearchParams();
  const queryString = searchParams.toString();
  const redirectPath = `/survey-form/${surveyId}${queryString ? `?${queryString}` : ''}`;
  return <Navigate to={redirectPath} replace />;
};

const router = createBrowserRouter([
  { path: "/", element: <ErrorPage /> },
  { path: "/login", element: <Login /> },
  { path: "/survey", element: <SurveyFormPage /> },
  { 
    path: "/agent/survey-form/:surveyId", 
    element: <AgentSurveyFormRedirect />
  },
  { path: "/survey-form/:surveyId", element: <SurveyFormPage /> },
  {
    path: "/survey-success",
    element: <SurveySuccess />,
  },
  {
    path: "/survey-analysis",
    element: <SurveyAnalysisPage />,
  },
  {
    path: "/onboarding",
    element: (
      <ProtectedRoute>
        <OnboardingPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/hired-candidates",
    element: (
      <ProtectedRoute>
        <HiredCandidatesFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <CompanyDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "/fixed-questions",
    element: (
      <ProtectedRoute>
        <FixedQuestionsPage />
      </ProtectedRoute>
    ),
  },
]);

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
